// extracted by mini-css-extract-plugin
export default {"wrap":"TenantGreeting_wrap__urCzN","title":"TenantGreeting_title__o1n2L","sub":"TenantGreeting_sub__V0Zgo"};